var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSurveyIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.167.667v1.666h2.505c.457 0 .828.371.828.828v13.345a.829.829 0 0 1-.828.827H1.327a.828.828 0 0 1-.827-.827V3.16c0-.457.37-.828.827-.828h2.506V.667h8.334ZM3.833 4H2.167v11.667h11.666V4h-1.666v1.667H3.833V4ZM5.5 12.333V14H3.833v-1.667H5.5Zm0-2.5V11.5H3.833V9.833H5.5Zm0-2.5V9H3.833V7.333H5.5Zm5-5h-5V4h5V2.333Z",
    fill: "#000"
  })));
};
export { SvgSurveyIcon as ReactComponent };
export default __webpack_public_path__ + "31cd74ba2af254c61c0cf870e7b0a736.svg";